import { ControlConstants } from "../../control/constant/ControlConstants";
import { SpriteProperties } from "../../control/properties/SpriteProperties";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { LoaderFontStyle } from "../style/CommonFontStyle";
import { LoaderStyle } from "../style/CommonStyle";
import { AbstractViewProperties } from "./AbstractViewProperties";
/**
 * AbstractLoaderProperties.ts
 */
export class AbstractLoaderProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            ((this.backgroundProperties === null && this.backgroundProperties === other.backgroundProperties) || this.backgroundProperties.equals(other.backgroundProperties)) &&
            this.versionFieldProperties.equals(other.versionFieldProperties);
    }
    setDefaultValues() {
        this.backgroundProperties = new SpriteProperties(LoaderStyle.BACKGROUND_ONLY, LoaderStyle.MODULE);
        this.versionFieldProperties = new TextFieldProperties(LoaderFontStyle.VERSION, null, null, ControlConstants.RIGHT);
    }
}
//# sourceMappingURL=AbstractLoaderProperties.js.map